import * as React from 'react';
import { useSelector } from 'react-redux';
import { FavoriteButton } from '../../components/Favorite/FavoriteButton';
import { Header as HeaderComponent } from '../../components/Header';
import { getDisplayName, getFromDevelopersPropsCount } from '../../selectors/newbuilding';
import { HeaderCall } from '../Call/HeaderCall';
import { HeaderCallbackButton } from '../CallbackButton';
import { FavoriteContainer } from '../Favorite';
import { MessageButtonContainer } from '../MessageButton';
import { HeaderReviewStat } from '../NewbuildingReviewsStat';
import { NewbuildingCompareButton } from '../NewbuildingCompareButton';

interface IHeaderProps {
  isFixed: boolean;
}

export const Header = ({ isFixed }: IHeaderProps) => {
  const name = useSelector(getDisplayName);
  const fromDeveloperPropsCount = useSelector(getFromDevelopersPropsCount);

  return (
    <HeaderComponent
      name={name}
      isFixed={isFixed}
      rating={<HeaderReviewStat />}
      compare={<NewbuildingCompareButton hideText={true} isHeader={true} />}
      call={<HeaderCall eventAction="Open_jk_card_blockStickytop" />}
      callback={<HeaderCallbackButton />}
      fromDeveloperPropsCount={fromDeveloperPropsCount}
      favorite={
        <FavoriteContainer
          button={FavoriteButton}
          buttonTheme="stroke_secondary"
          buttonSize="M"
          hideText={true}
          isHeader={true}
        />
      }
      message={<MessageButtonContainer isHeaderButton={true} buttonSize="M" />}
    />
  );
};
